export default __webpack_public_path__ + "static/media/4.1e32cd41.jpg";